import React from 'react';
import { Container, Row, Col, Card, CardBody, Table, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart, faUsers, faMoneyBillWave, faSitemap } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";

function Dsr() {
    const dsrFundDetails = [
        "Marriage Grant given to war Widows, disabled Ex-servicemen and orphan daughters of ESM.",
        "Construction/Renewation/Maintenance of Distt. Level War Memorials.",
        "Financial Assistance to Paralysed Ex-Servicemen for the construction of Toilet-Cum-Bathroom.",
        "Additional pension.",
        "Entertainment fund",
    ];

    const amalgamatedFundDetails = [
        "Stipends for education, loans for resettlement projects, scholarships for dependents, assistance for elderly ESM and widows, funding for Sainik Rest Houses, and organizing annual rallies.",
        "Grants for medical treatment, specialized care for chronic diseases and disabilities, funding for training institutions, and provisions for widows and families.",
    ];

    const dsrManagingCommittee = [
        { srNo: 1, designation: 'Chief Minister Haryana', role: 'Chairman' },
        { srNo: 2, designation: 'Minister-in-Charge', role: 'Vice Chairman' },
        { srNo: 3, designation: 'Chief Secretary', role: 'Ex-Officio Member' },
        { srNo: 4, designation: 'Administrative Secretary SASW, Deptt.', role: 'Ex-Officio Member' },
        { srNo: 5, designation: 'Additional Chief Secretary to Government Haryana, Finance Deptt.', role: 'Ex-Officio Member' },
        { srNo: 6, designation: 'Additional Chief Secretary to Government Haryana, Home Deptt.', role: 'Ex-Officio Member' },
        { srNo: 7, designation: 'Additional Chief Secretary to Govt. Haryana, PWD (B&R)', role: 'Ex-Officio Member' },
        { srNo: 8, designation: 'Engineer-in-Chief, PWD (B&R) Haryana', role: 'Ex-Officio Member' },
        { srNo: 9, designation: 'General Officer Commanding, PH & HP(I)Sub Area, Ambala Cantt', role: 'Ex-Officio Member' },
        { srNo: 10, designation: 'Air Officer Commanding, Air Force Station, Ambala Cantt.', role: 'Ex-Officio Member' },
        { srNo: 11, designation: 'Director General, Sainik and ArdhSainik Welfare Deptt. Cum-Secretary Rajya Sainik Board.', role: 'Member Secretary' },
    ];

    const amalgamatedManagingCommittee = [
        { srNo: 1, designation: 'Governor of Haryana', role: 'Chairman' },
        { srNo: 2, designation: 'Chief Minister Haryana', role: 'Vice Chairman' },
        { srNo: 3, designation: 'Minister-in-Charge', role: 'Deputy Vice Chairman' },
        { srNo: 4, designation: 'Chief Secretary', role: 'Member' },
        { srNo: 5, designation: 'Administrative Secretary SASW, Deptt.', role: 'Member' },
        { srNo: 6, designation: 'Additional Secretary to Government of India, Ministry of Defence', role: 'Member' },
        { srNo: 7, designation: 'General Officer Commanding, PH & HP(I)Sub Area, Ambala Cantt', role: 'Member' },
        { srNo: 8, designation: 'Director General Resettlement Govt. of India Ministry of Defence, New Delhi.', role: 'Member' },
        { srNo: 9, designation: 'Finance Secretary', role: 'Member' },
        { srNo: 10, designation: 'Two Ex-Serviceman Officers of Haryana State having interest in welfare, Ex-serviceman to be nominated by State Govt.', role: 'Member' },
        { srNo: 11, designation: 'Two nominees of Chief’s of Staff Committee out of Ex-serviceman Officers residing in the State.', role: 'Member' },
        { srNo: 12, designation: 'One distinguished JCO/Honorary Commissioned Officer or equivalent rank of Indian Navy Or Indian Air Force residing in Haryana State.', role: 'Member' },
        { srNo: 13, designation: 'Director General, Sainik and ArdhSainik Welfare Deptt. Cum-Secretary Rajya Sainik Board.', role: 'Member Secretary' },
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faHandHoldingHeart} className="me-2" />
                        DSR & Amalgamated Fund
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                {/* DSR Fund Details */}
                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                padding: '25px',
                                color: 'white'
                            }}>
                                <h4 className="fw-bold mb-0">
                                    <FontAwesomeIcon icon={faMoneyBillWave} className="me-2" />
                                    Haryana Defence & Security Relief (DSR) Fund
                                </h4>
                            </div>
                            <CardBody className="p-4">
                                <ListGroup flush>
                                    {dsrFundDetails.map((detail, index) => (
                                        <ListGroupItem key={index} className="px-0 py-3 border-bottom" style={{ borderColor: '#e9ecef' }}>
                                            <FontAwesomeIcon icon={faHandHoldingHeart} className="me-2" style={{ color: '#1e3c72' }} />
                                            <span style={{ color: '#495057' }}>{detail}</span>
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* DSR Managing Committee */}
                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(22,160,133,0.15)' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                padding: '25px',
                                color: 'white'
                            }}>
                                <h4 className="fw-bold mb-0">
                                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                                    DSR Fund Managing Committee
                                </h4>
                            </div>
                            <CardBody className="p-4">
                                <Table responsive bordered hover className="mb-0">
                                    <thead style={{ background: '#f8f9fa' }}>
                                        <tr>
                                            <th style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Sr.No</th>
                                            <th style={{ background: '#1e3c72', color: 'white', width: '60%' }}>Designation</th>
                                            <th style={{ background: '#1e3c72', color: 'white', width: '30%' }}>Designated as</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dsrManagingCommittee.map((member) => (
                                            <tr key={member.srNo}>
                                                <td style={{ color: '#495057' }}>{member.srNo}</td>
                                                <td style={{ color: '#495057' }}>{member.designation}</td>
                                                <td style={{ color: '#16a085', fontWeight: '600' }}>{member.role}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Amalgamated Fund */}
                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(142,68,173,0.15)' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                                padding: '25px',
                                color: 'white'
                            }}>
                                <h4 className="fw-bold mb-0">
                                    <FontAwesomeIcon icon={faSitemap} className="me-2" />
                                    Amalgamated Fund
                                </h4>
                            </div>
                            <CardBody className="p-4">
                                <ListGroup flush>
                                    {amalgamatedFundDetails.map((detail, index) => (
                                        <ListGroupItem key={index} className="px-0 py-3 border-bottom" style={{ borderColor: '#e9ecef' }}>
                                            <FontAwesomeIcon icon={faHandHoldingHeart} className="me-2" style={{ color: '#8e44ad' }} />
                                            <span style={{ color: '#495057', lineHeight: '1.8' }}>{detail}</span>
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Amalgamated Managing Committee */}
                <Row>
                    <Col lg={12}>
                        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                            <div style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                padding: '25px',
                                color: 'white'
                            }}>
                                <h4 className="fw-bold mb-0">
                                    <FontAwesomeIcon icon={faUsers} className="me-2" />
                                    Amalgamated Fund State Managing Committee
                                </h4>
                            </div>
                            <CardBody className="p-4">
                                <Table responsive bordered hover className="mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ background: '#8e44ad', color: 'white', width: '10%' }}>Sr.No</th>
                                            <th style={{ background: '#8e44ad', color: 'white', width: '60%' }}>Designation</th>
                                            <th style={{ background: '#8e44ad', color: 'white', width: '30%' }}>Designated as</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {amalgamatedManagingCommittee.map((member) => (
                                            <tr key={member.srNo}>
                                                <td style={{ color: '#495057' }}>{member.srNo}</td>
                                                <td style={{ color: '#495057' }}>{member.designation}</td>
                                                <td style={{ color: '#8e44ad', fontWeight: '600' }}>{member.role}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Dsr;
